// extracted by mini-css-extract-plugin
export default {"modalButtons":"CenterBottomBox_modalButtons__IQ7vj","modalBtn":"CenterBottomBox_modalBtn__ewaHU"};